export default {
  get name(): string {
    return 'ExponentHaptic';
  },
};
